import React from "react";
import { MessageMedia } from "@/model/interface/Message";

interface MediaAttachmentProps {
  media: MessageMedia;
}

const MediaAttachment: React.FC<MediaAttachmentProps> = ({ media }) => {
  if (media.contentType.startsWith("image/")) {
    return (
      <img
        src={media.url}
        alt={media.fileName || "Image"}
        className="rounded max-w-full max-h-64 object-contain"
      />
    );
  }

  return (
    <a
      href={media.url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-sm underline"
    >
      {media.fileName || "Download attachment"}
    </a>
  );
};

export default MediaAttachment;
